import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Hive Case Study | Canny';
const Description =
  'Read about how Hive uses Canny to collaborate across departments and increase their NPS.';
const Image = 'https://canny.io/images/88ffedfc7492b0896a70e26233754e7e.jpg';
const HiveUrl = 'https://canny.io/case-studies/hive';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${HiveUrl}#webpage`,
    url: HiveUrl,
    name: 'Case Study: Hive × Canny',
    description: 'How Hive uses Canny to collaborate across departments and increase their NPS.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${HiveUrl}#article`,
    genre: 'Case Study',
    headline: 'How Hive uses Canny to collaborate across departments and increase their NPS',
    description:
      'Hive shifted to a community-first model in 2020 and adopted Canny as a unified feedback hub used by product, marketing, and sales. The intuitive UI and Zapier integration saved them 2–3 hours per week on product marketing and helped them consistently improve their NPS, all while enabling internal collaboration and a thriving feedback community.',
    inLanguage: 'en',
    url: HiveUrl,
    mainEntityOfPage: { '@id': `${HiveUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Hive', url: 'https://hive.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Hive', item: HiveUrl },
  ]),
]);

export default class HiveLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: HiveUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
